export interface ITrainersImage {
  desktop_img_url: string;
  desktop_img_sizes: string;
  default: string;
}

export interface ITrainer {
  name: string;
  description: string;
  img: ITrainersImage;
  active: boolean;
}

const trainers: ITrainer[] = [
  {
    name: 'Flo Master',
    description: 'Flo is a lifelong martial artist who is well-regarded as a legend and pioneer in the hip-hop/breakdancing scene. He has an innovative, high-energy training style and has worked closely with top performance artist, Usher and UFC superstar Anderson Silva.',
    img: {
      desktop_img_url: 'v4/fc-kickboxing-flo-001.jpg',
      desktop_img_sizes: '(max-width: 758px) 50vw, (max-width: 1200px) 33vw, 400px',
      default: 'https://cdn3.joinfightcamp.com/v4/fc-kickboxing-flo-001.jpg',
    },
    active: false,
  },
  {
    name: 'Aaron Swenson',
    description: 'Aaron Swenson is an accomplished fighter with two National Kickboxing titles, and he once held a spot on the USA National Kickboxing Team. Aaron left the ring with an overall record of 27 wins and seven losses across kickboxing, boxing, and Muay Thai.',
    img: {
      desktop_img_url: 'v4/fc-kickboxing-aaron-001.jpg',
      desktop_img_sizes: '(max-width: 758px) 50vw, (max-width: 1200px) 33vw, 400px',
      default: 'https://cdn3.joinfightcamp.com/v4/fc-kickboxing-aaron-001.jpg',
    },
    active: true,
  },
  {
    name: 'Shanie Smash',
    description: 'Shanie has done everything from modeling to competing professionally in MMA. She has a winning record of two wins and no losses. Driven to sweat it out and inspire others, Shanie is one of the most electrifying trainers you\'ll meet.',
    img: {
      desktop_img_url: 'v4/fc-kickboxing-shanie-001.jpg',
      desktop_img_sizes: '(max-width: 758px) 50vw, (max-width: 1200px) 33vw, 400px',
      default: 'https://cdn3.joinfightcamp.com/v4/fc-kickboxing-shanie-001.jpg',
    },
    active: false,
  },
];

export default trainers;
